import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { deleteComment, deleteGameComment } from '~/api';
import { DeleteCommentRequest, Chat01RoomType } from '~/types';
import { DeleteGameCommentRequest } from '~/types/missionGameApi';
import useUpdateCommentList from './useUpdateCommentList';
import useUpdateGameCommentList from './useUpdateGameCommentList';

export const useDeleteCommentMutation = (type: Chat01RoomType) => {
  const { deleteCommentList, updatePersonaDetailsTotalComment } =
    useUpdateCommentList();

  return useMutation({
    mutationFn: (newComment: DeleteCommentRequest) => deleteComment(newComment),
    onSuccess: ({ status }, request) => {
      deleteCommentList(request);
      updatePersonaDetailsTotalComment(
        {
          character_id: request.character_id,
          // type,
        },
        'delete',
      );
    },
    onError: (error) => {
      console.error('Error creating comment:', error);
    },
  });
};

export const useDeleteGameCommentMutation = () => {
  const { deleteGameCommentList, updateGameDetailsTotalComment } =
    useUpdateGameCommentList();

  return useMutation({
    mutationFn: (newComment: DeleteGameCommentRequest) =>
      deleteGameComment(newComment),
    onSuccess: ({ status }, request) => {
      deleteGameCommentList(request);

      updateGameDetailsTotalComment(
        {
          game_id: request.game_id,
        },
        'delete',
      );
    },
    onError: (error) => {
      console.error('Error creating comment:', error);
    },
  });
};
